export const FACEBOOK = "21636";
export const XING = "21637";
export const LINKEDIN = "21638";
export const TWITTER = "21639";
export const WEITERE = "29300";
